import { TColorScheme } from "./colors.types";

export default {
  white: "#fff",
  black: "#000",
  primary: {
    100: "#d6fff1",
    200: "#b8fee7",
    300: "#86f3cf",
    400: "#5cebbb",
    500: "#1ec88e",
    600: "#1db682",
    700: "#109367",
    800: "#06744f",
    900: "#03593c",
  },
  secondary: {
    100: "#f1e6ff",
    200: "#e0c7fe",
    300: "#cba5fa",
    400: "#b985f9",
    500: "#a564f7",
    600: "#964cf0",
    700: "#8919eb",
    800: "#740dce",
    900: "#6202ac",
  },
  neutral: {
    100: "#f8fafc",
    200: "#ecf0f3",
    300: "#dae1e7",
    400: "#c5cfd8",
    500: "#a9b9c6",
    600: "#8999a9",
    700: "#677783",
    800: "#515d67",
    900: "#434e56",
    1000: "#353e46",
    1100: "#293138",
    1200: "#1D252B",
  },
  error: {
    100: "#ffe0e0",
    200: "#fdc4c4",
    300: "#fd9b9b",
    400: "#fb7e7e",
    500: "#f86262",
    600: "#f14b4b",
    700: "#e11414",
    800: "#cb0606",
    900: "#ad0000",
  },
  warning: {
    100: "#fff9e0",
    200: "#fdf2c4",
    300: "#fceaa1",
    400: "#fbe27e",
    500: "#f3c920",
    600: "#e9bc07",
    700: "#dcb104",
    800: "#c79f00",
    900: "#AD8B00",
  },
  info: {
    100: "#e0f5ff",
    200: "#c2eafe",
    300: "#a1daf7",
    400: "#7ec8ec",
    500: "#54add9",
    600: "#2d98cd",
    700: "#2283b4",
    800: "#1c719c",
    900: "#1a6489",
  },
  blue: {
    100: "#E5ECFF",
    200: "#D1DAFF",
    300: "#B9C4FE",
    400: "#A5B1FD",
    500: "#919CFD",
    600: "#8286FC",
    700: "#7672FE",
    800: "#6A5FFC",
    900: "#6A21FD",
  },
  orange: {
    100: "#FFE7D1",
    200: "#FED1AA",
    300: "#FEBF8B",
    400: "#FDAB68",
    500: "#FB9A4B",
    600: "#F88825",
    700: "#F27507",
    800: "#E36802",
    900: "#E36802",
  },
  pink: {
    100: "#FFE5F4",
    200: "#FFCCE9",
    300: "#FEB3DE",
    400: "#FE9AD3",
    500: "#FC82C7",
    600: "#FC64B8",
    700: "#FD44AA",
    800: "#FA0A96",
    900: "#E60584",
  },
  success: {
    100: "#f6ffed",
    200: "#d9f7be",
    300: "#b7eb8f",
    400: "#95de64",
    500: "#73d13d",
    600: "#52c41a",
    700: "#389e0d",
    800: "#237804",
    900: "#135200",
  },
} as TColorScheme;
